export default {
    SET_STABLE_COINS: (state, { providerId, stableCoins }) => {
        state.providerId = providerId;
        state.stableCoins = stableCoins;
    },
};
